import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Collapse,
  Container,
  Form,
  FormGroup,
  Label,
  Row,
} from "reactstrap"
import { connect } from "react-redux"
import { useLocation, withRouter } from "react-router-dom"

//Date Picker
import { registerLocale, setDefaultLocale } from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import "assets/scss/datatables.scss"
import "react-phone-number-input/style.css"

import ptBR from "date-fns/locale/pt-BR"
//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"
import { navegarBreadCrumb } from "../../store/navigator/actions"

import {
  buscarAgendaPorEmpresa,
  buscarConfigIfoodPorEmpresa,
  buscarEmpresa,
  buscarLicencasPorEmpresa,
  buscarNotificacoesSistemaPorEmpresa,
  buscarTarefasPorEmpresa,
  buscarTiposEmpresa,
  editarEmpresa,
  navegarEditarEmpresa,
} from "../../store/auth/profile/actions"
import usePermission from "helpers/permission/usePermission"
import StickerToolbarButtons from "../../components/Common/sticker-toolbar-buttons"
import AlertaSemVinculo from "../../components/Common/alerta-sem-vinculo"
import Loader from "react-loader-spinner"
import FormInputSwitch from "../../components/Common/form-input-switch"
import FormInputNumber from "../../components/Common/form-input-number"
import FormInputText from "../../components/Common/form-input-text"
import "toastr/build/toastr.min.css"
import FormInputDate from "../../components/Common/form-input-date"
import moment from "moment-timezone"
import EmpresaLicencaLista from "./empresa-licenca-lista"
import EmpresaTarefaLista from "./empresa-tarefas-lista"
import EmpresaNotificacaoLista from "./empresa-notificacoes-lista"
import { isEmailValid } from "../../helpers/utils"
import FormInputEmail from "../../components/Common/form-input-email"
import toastr from "toastr"
import ButtonRedirect from "../../components/Common/button-redirect"
import FormInputSelect from "../../components/Common/form-input-select"
import EmpresaConfigIfoodLista from "./empresa-config-ifood-lista"
import EmpresaRelatorioLista from "./empresa-relatorio-lista"
import { withTranslation } from "react-i18next"
import { v4 as uuidv4 } from "uuid"

const brazilMoment = (...args) => moment(...args)
registerLocale("ptBR", ptBR)
setDefaultLocale("ptBR")

const CadastrarEmpresa = props => {
  const [paramIdCloud, setParamIdCloud] = useState(undefined)
  const possuiVinculo = (props.user?.vinculos || []).some(vinculo =>
    ["A", "T"].includes(vinculo.vinculo_status)
  )
  const isInforangra = props.user?.usuario_info !== null
  const isInforangraAdmin =
    props.user?.usuario_info && props.user?.usuario_info?.perfil?.administrador
  const usePermissionEdit = usePermission("empresas_editar")
  const [loading, setLoading] = useState(false)

  const [id, setId] = useState()
  const [empresaId, setEmpresaId] = useState()
  const [razaoSocial, setRazaoSocial] = useState()
  const [fantasia, setFantasia] = useState()
  const [cnpj, setCnpj] = useState()
  const [emailContator, setEmailContador] = useState()
  const [tipoEmpresa, setTipoEmpresa] = useState()
  const [email, setEmail] = useState()
  const [envioRemessaAutomatico, setEnvioRemessaAutomatico] = useState()
    const [dashboardIA, setDashboardIA] = useState()
  const [diaEnviarRemessa, setDiaEnviarRemessa] = useState()
  const [urlCertificado, setUrlCertificado] = useState()
  const [tipoCertificado, setTipoCertificado] = useState()
  const [validadeCertificado, setValidadeCertificado] = useState()
  const [dataEnvioCertificado, setDataEnvioCertificado] = useState()
  const [usuarioEnvioCertificado, setUsuarioDataEnvioCertificado] = useState()
  const [dataAlteracao, setDataAlteracao] = useState()
  const [usuarioAlteracao, setUsuarioAlteracao] = useState()
  const [accordionRemessa, setAccordionRemessa] = useState(true)
  const [accordionCertificadoDigital, setAccordionCertificadoDigital] =
    useState(true)
  const [accordionRegistroLicencas, setAccordionRegistroLicencas] =
    useState(true)
  const [accordionTarefas, setAccordionTarefas] = useState(true)
  const [accordionNotificacoes, setAccordionNotificacoes] = useState(true)
  const [accordionConfigIfood, setAccordionConfigIfood] = useState(true)
  const [accordionTarefasAgendadas, setAccordionTarefasAgendadas] =
    useState(true)
  const [accordionGASS, setAccordionGASS] = useState(true)
  const location = useLocation()
  const [tiposOptions, setTiposOptions] = useState([])
  const [chaveGASS, setChaveGASS] = useState()

  const getAndSearch = idCloud => {
    props.buscarEmpresa({ id: idCloud }, props.history)
    props.navegarBreadCrumb({
      title: `breadcrumb.company`,
      link: location.pathname,
      id: idCloud,
    })
  }

  useEffect(() => {
    if (paramIdCloud !== undefined) return

    const idCloud = props.match.params.hasOwnProperty("idCloud")
      ? props.match.params.idCloud
      : null
    if (idCloud) {
      getAndSearch(idCloud)
    } else {
      preencherFormulario(null)
      setId(null)
      props.navegarBreadCrumb({
        title: `breadcrumb.company.new`,
        link: location.pathname,
      })
    }

    setParamIdCloud(idCloud)
  }, [props.match.params])

  useEffect(() => {
    if (props.tiposEmpresa && props.tiposEmpresa.length > 0) {
      setTiposOptions(
        props.tiposEmpresa.map(item => ({
          value: item.tipo,
          label: item.descricao,
        }))
      )
    }
  }, [props.tiposEmpresa])

  useEffect(() => {
    if (props.empresa && props.empresa?.id) {
      preencherFormulario(props.empresa)

      props.buscarTarefasPorEmpresa({
        company: props.empresa?.idEmpresa,
        ignoreCompany: true,
      })

      props.buscarLicencasPorEmpresa({
        company: props.empresa?.idEmpresa,
        ignoreCompany: true,
      })

      props.buscarNotificacoesSistemaPorEmpresa({
        company: props.empresa?.idEmpresa,
        ignoreCompany: true,
      })

      props.buscarConfigIfoodPorEmpresa({
        company: props.empresa?.idEmpresa,
        ignoreCompany: true,
      })

      props.buscarAgendaPorEmpresa({
        company: props.empresa?.idEmpresa,
        ignoreCompany: true,
      })

      props.buscarTiposEmpresa()
    }
  }, [props.empresa])

  const preencherFormulario = empresa => {
    setId(empresa?.id)
    setEmpresaId(empresa?.idEmpresa)
    setRazaoSocial(empresa?.RazaoSocial)
    setFantasia(empresa?.Fantasia)
    setCnpj(empresa?.CNPJ)
    setEmailContador(empresa?.EmailContador)
    setEmail(empresa?.Email)
    setEnvioRemessaAutomatico(
      empresa?.RemessaAutomatica ? empresa?.RemessaAutomatica : "N"
    )
        setDashboardIA(empresa?.DashboardIA ? empresa?.DashboardIA : 'N')
    setDiaEnviarRemessa(empresa?.RemessaDia)
    setUrlCertificado(empresa?.certificado?.Certificado_url_s3)
    setTipoCertificado(empresa?.certificado?.Certificado_tipo)
    setValidadeCertificado(
      empresa?.certificado?.Certificado_validade
        ? brazilMoment(
            empresa?.certificado?.Certificado_validade,
            "YYYY-MM-DD"
          ).toDate()
        : null
    )
    setDataEnvioCertificado(
      empresa?.certificado?.Certificado_data_envio
        ? brazilMoment(
            empresa?.certificado?.Certificado_data_envio,
            "YYYY-MM-DD HH:mm:ss"
          ).toDate()
        : null
    )
    setUsuarioDataEnvioCertificado(
      empresa?.certificado?.Certificado_usuario || "N/A"
    )
    setDataAlteracao(
      empresa?.AltData
        ? brazilMoment(empresa?.AltData, "YYYY-MM-DD HH:mm:ss").toDate()
        : null
    )
    setUsuarioAlteracao(
      `${empresa?.AltFunc} - ${empresa?.AltFunc_Nome || "N/A"}`
    )
    setTipoEmpresa(empresa.empresa_tipo)
    setChaveGASS(empresa?.chaveGASS)

    if (isCertificadoVencido()) {
      const divs = document.getElementById("validate-validadeCertificado-date")
      divs.style.display = "block"
    }
  }

  const gravarEmpresa = e => {
    const empresa = props.empresa ? Object.assign({}, props.empresa) : {}

    let valid = true
    const emailValid = email && email !== "" ? isEmailValid(email) : false
    valid = valid && emailValid

    const emailContatorValid =
      emailContator && emailContator !== ""
        ? isEmailValid(emailContator)
        : false
    valid = valid && emailContatorValid

    valid = valid && tipoEmpresa

    if (valid) {
      empresa.id = id
      empresa.Email = email
      empresa.EmailContador = emailContator
      empresa.RemessaAutomatica = envioRemessaAutomatico
      empresa.RemessaDia = diaEnviarRemessa
      empresa.empresa_tipo = tipoEmpresa
            empresa.DashboardIA = dashboardIA
      empresa.chaveGASS = chaveGASS

      props.editarEmpresa(empresa, props.history)
    } else {
      const divs = [...document.getElementsByName("validate-required")]
      for (let i = 0; i < divs.length; i++) {
        divs[i].style.display = "block"
      }

      window.scrollTo(0, 0)
      toastr.error(
        props.t("empresa.edicao.campos.erro"),
        props.t("empresa.edicao.validacao.erro")
      )
    }
  }

  const isCertificadoVencido = () => {
    return validadeCertificado ? validadeCertificado < new Date() : false
  }

  const podeGravar = () => {
    let podeGravar = false
    if (isInforangraAdmin) {
      podeGravar = true
    } else if (isInforangra) {
      podeGravar = (props.user?.vinculos || [])
        .map(vinculo => vinculo.empresa?.idEmpresa)
        .includes(empresaId)
    }

    return podeGravar
  }

  if (!props.user || !possuiVinculo) {
    return <AlertaSemVinculo />
  }

  return (
    <React.Fragment>
      {props.empresaLoading || loading ? (
        <div className="loader-container position-absolute">
          <Loader type="ThreeDots" color="#556EE6" height={80} width={80} />
        </div>
      ) : (
        <div className="page-content">
          <Container fluid>
            <Breadcrumbs title="breadcrumb.company.title" />
            <StickerToolbarButtons>
              <ButtonRedirect
                path={"empresas"}
                history={props.history}
              ></ButtonRedirect>
              {id && (
                <>
                  <Button
                    type="submit"
                    color="primary"
                    className="waves-effect waves-light me-2"
                    disabled={!usePermissionEdit || !podeGravar()}
                    onClick={e => gravarEmpresa(e)}
                  >
                    {props.t("empresa.edicao.salvar.label")}
                  </Button>
                </>
              )}
            </StickerToolbarButtons>

            <Row>
              <Col lg="12">
                <div>
                  <Card>
                    <CardBody>
                      <CardTitle className="mb-4">
                        {props.t("empresa.edicao.titulo.label")}
                      </CardTitle>
                      <Form>
                        <div className="outer">
                          <div className="outer">
                            {id && (
                              <FormGroup className="mb-4" row>
                                <Label
                                  htmlFor="empresa"
                                  className="col-form-label col-lg-2"
                                >
                                  {props.t("empresa.edicao.id.label")}
                                </Label>
                                <Col lg="10" className="col-form-label">
                                  {id}
                                </Col>
                              </FormGroup>
                            )}

                            {id && (
                              <FormGroup className="mb-4" row>
                                <Label
                                  htmlFor="codigo"
                                  className="col-form-label col-lg-2"
                                >
                                  {props.t("empresa.edicao.codigo.label")}
                                </Label>
                                <Col lg="10" className="col-form-label">
                                  {empresaId}
                                </Col>
                              </FormGroup>
                            )}

                            <FormInputText
                              attribute="razaoSocial"
                              description={props.t(
                                "empresa.edicao.razaoSocial.label"
                              )}
                              value={razaoSocial}
                              setValue={setRazaoSocial}
                              required={true}
                              maxLength={70}
                              disabled={true}
                            />

                            <FormInputText
                              attribute="fantasia"
                              description={props.t(
                                "empresa.edicao.fantasia.label"
                              )}
                              value={fantasia}
                              setValue={setFantasia}
                              required={true}
                              maxLength={70}
                              disabled={true}
                            />

                            <FormInputText
                              attribute="cnpj"
                              description={props.t("empresa.edicao.cnpj.label")}
                              value={cnpj}
                              setValue={setCnpj}
                              required={true}
                              maxLength={70}
                              disabled={true}
                            />

                            <FormInputEmail
                              attribute="email"
                              description={props.t(
                                "empresa.edicao.email.label"
                              )}
                              value={email}
                              setValue={setEmail}
                              required={true}
                              maxLength={70}
                              disabled={!usePermissionEdit}
                              validacao={isEmailValid(email)}
                              validacaoMensagem={props.t(
                                "empresa.edicao.email.invalid.label"
                              )}
                            />

                            <FormInputEmail
                              attribute="emailContator"
                              description={props.t(
                                "empresa.edicao.emailContador.label"
                              )}
                              value={emailContator}
                              setValue={setEmailContador}
                              required={true}
                              maxLength={70}
                              disabled={!usePermissionEdit}
                              validacao={isEmailValid(emailContator)}
                              validacaoMensagem={props.t(
                                "empresa.edicao.emailContador.validacao.label"
                              )}
                            />

                            <FormInputSelect
                              attribute="tipo"
                              description={props.t("empresa.edicao.tipo.label")}
                              value={tipoEmpresa}
                              setValue={setTipoEmpresa}
                              options={tiposOptions}
                              required={true}
                            />

                                                <FormInputSwitch
                                                    attribute="dashboardIA"
                                                    description={props.t("empresa.edicao.accordion.dashboard.ia")}
                                                    value={dashboardIA}
                                                    setValue={setDashboardIA}
                                                    disabled={!usePermissionEdit}
                                                />

                          </div>
                        </div>
                      </Form>

                      <div className="hstack gap-3 mb-2 mt-5">
                        <Label className="col-form-label">
                          {props.t("empresa.edicao.quadro.label")}
                        </Label>
                        <button
                          type="button"
                          className="btn btn-soft-primary btn-sm"
                          onClick={e => {
                            setAccordionRemessa(true)
                            setAccordionCertificadoDigital(true)
                            setAccordionRegistroLicencas(true)
                            setAccordionTarefas(true)
                            setAccordionNotificacoes(true)
                            setAccordionConfigIfood(true)
                            setAccordionTarefasAgendadas(true)
                            setAccordionGASS(true)
                          }}
                        >
                          {props.t("empresa.edicao.quadro.exibir-todos.label")}
                        </button>
                        <button
                          type="button"
                          className="btn btn-soft-secondary btn-sm"
                          onClick={e => {
                            setAccordionRemessa(false)
                            setAccordionCertificadoDigital(false)
                            setAccordionRegistroLicencas(false)
                            setAccordionTarefas(false)
                            setAccordionNotificacoes(false)
                            setAccordionConfigIfood(false)

                            setAccordionTarefasAgendadas(false)
                            setAccordionGASS(false)
                          }}
                        >
                          {props.t("empresa.edicao.quadro.nao-exibir.label")}
                        </button>
                        <button
                          type="button"
                          className="btn btn-soft-secondary btn-sm"
                          onClick={e => {
                            setAccordionRemessa(true)
                            setAccordionCertificadoDigital(false)
                            setAccordionRegistroLicencas(false)
                            setAccordionTarefas(false)
                            setAccordionNotificacoes(false)
                            setAccordionConfigIfood(false)
                            setAccordionTarefasAgendadas(false)
                            setAccordionGASS(false)
                          }}
                        >
                          {props.t(
                            "empresa.edicao.quadro.exibir-padroes.label"
                          )}
                        </button>
                      </div>

                      <div
                        className="btn-group btn-group-toggle"
                        data-toggle="buttons"
                      >
                        <label
                          className={
                            accordionRemessa
                              ? "btn btn-secondary active"
                              : "btn btn-secondary"
                          }
                        >
                          <input
                            type="checkbox"
                            className="btn-check"
                            onClick={() => {
                              setAccordionRemessa(!accordionRemessa)
                            }}
                          />{" "}
                          {props.t("empresa.edicao.accordion.remessa.label")}
                        </label>
                        <label
                          className={
                            accordionCertificadoDigital
                              ? "btn btn-secondary active"
                              : "btn btn-secondary"
                          }
                        >
                          <input
                            type="checkbox"
                            className="btn-check"
                            onClick={() => {
                              setAccordionCertificadoDigital(
                                !accordionCertificadoDigital
                              )
                            }}
                          />{" "}
                          {props.t(
                            "empresa.edicao.accordion.certificado.label"
                          )}
                        </label>
                        <label
                          className={
                            accordionRegistroLicencas
                              ? "btn btn-secondary active"
                              : "btn btn-secondary"
                          }
                        >
                          <input
                            type="checkbox"
                            className="btn-check"
                            onClick={() => {
                              setAccordionRegistroLicencas(
                                !accordionRegistroLicencas
                              )
                            }}
                          />{" "}
                          {props.t(
                            "empresa.edicao.accordion.registro-licencas.label"
                          )}
                        </label>
                        <label
                          className={
                            accordionTarefas
                              ? "btn btn-secondary active"
                              : "btn btn-secondary"
                          }
                        >
                          <input
                            type="checkbox"
                            className="btn-check"
                            onClick={() => {
                              setAccordionTarefas(!accordionTarefas)
                            }}
                          />{" "}
                          {props.t("empresa.edicao.accordion.tarefas.label")}
                        </label>
                        <label
                          className={
                            accordionNotificacoes
                              ? "btn btn-secondary active"
                              : "btn btn-secondary"
                          }
                        >
                          <input
                            type="checkbox"
                            className="btn-check"
                            onClick={() => {
                              setAccordionNotificacoes(!accordionNotificacoes)
                            }}
                          />{" "}
                          {props.t(
                            "empresa.edicao.accordion.notificacoes.label"
                          )}
                        </label>
                        <label
                          className={
                            accordionConfigIfood
                              ? "btn btn-secondary active"
                              : "btn btn-secondary"
                          }
                        >
                          <input
                            type="checkbox"
                            className="btn-check"
                            onClick={() => {
                              setAccordionConfigIfood(!accordionConfigIfood)
                            }}
                          />{" "}
                          {props.t(
                            "empresa.edicao.accordion.config-ifood.label"
                          )}
                        </label>

                        <label
                          className={
                            accordionTarefasAgendadas
                              ? "btn btn-secondary active"
                              : "btn btn-secondary"
                          }
                        >
                          <input
                            type="checkbox"
                            className="btn-check"
                            onClick={() => {
                              setAccordionTarefasAgendadas(
                                !accordionTarefasAgendadas
                              )
                            }}
                          />{" "}
                          {props.t("empresa.edicao.accordion.relatorios.label")}
                        </label>

                        <label
                          className={
                            accordionGASS
                              ? "btn btn-secondary active"
                              : "btn btn-secondary"
                          }
                        >
                          <input
                            type="checkbox"
                            className="btn-check"
                            onClick={() => {
                              setAccordionGASS(!accordionGASS)
                            }}
                          />{" "}
                          GASS
                        </label>
                      </div>
                    </CardBody>
                  </Card>

                  <Collapse isOpen={accordionRemessa}>
                    <Card>
                      <CardBody>
                        <CardTitle className="mb-4">
                          {props.t("empresa.edicao.accordion.remessa.label")}
                        </CardTitle>
                        <Form>
                          <div className="outer">
                            <div className="outer">
                              <FormInputSwitch
                                attribute="envioRemessaAutomatico"
                                description={props.t(
                                  "empresa.edicao.accordion.remessa.envio"
                                )}
                                value={envioRemessaAutomatico}
                                setValue={setEnvioRemessaAutomatico}
                                disabled={!usePermissionEdit}
                              />

                              <FormInputNumber
                                attribute="diaEnviarRemessa"
                                description={props.t(
                                  "empresa.edicao.accordion.remessa.dia"
                                )}
                                value={diaEnviarRemessa}
                                setValue={setDiaEnviarRemessa}
                                allowNegative={false}
                                max={9999999}
                                min={0}
                                disabled={!usePermissionEdit}
                              />
                            </div>
                          </div>
                        </Form>
                      </CardBody>
                    </Card>
                  </Collapse>

                  <Collapse isOpen={accordionCertificadoDigital}>
                    <Card>
                      <CardBody>
                        <CardTitle className="mb-4">
                          {props.t(
                            "empresa.edicao.accordion.certificado.label"
                          )}
                        </CardTitle>

                        <Form>
                          <div className="outer">
                            <div className="outer">
                              <FormInputText
                                attribute="urlCertificado"
                                description={props.t(
                                  "empresa.edicao.accordion.certificado.urlCertificado"
                                )}
                                value={urlCertificado}
                                setValue={setUrlCertificado}
                                disabled={true}
                              />

                              <FormInputText
                                attribute="tipoCertificado"
                                description={props.t(
                                  "empresa.edicao.accordion.certificado.tipoCertificado"
                                )}
                                value={tipoCertificado}
                                setValue={setTipoCertificado}
                                disabled={true}
                              />

                              <FormInputDate
                                attribute="validadeCertificado"
                                description={props.t(
                                  "empresa.edicao.accordion.certificado.validade"
                                )}
                                value={validadeCertificado}
                                disabled={true}
                                dateFormat={"dd/MM/yyyy"}
                                validacao={!isCertificadoVencido()}
                                validacaoMensagem={
                                  "O certificado está vencido!"
                                }
                              />

                              <FormInputDate
                                attribute="dataEnvioCertificado"
                                description={props.t(
                                  "empresa.edicao.accordion.certificado.data"
                                )}
                                value={dataEnvioCertificado}
                                disabled={true}
                                dateFormat={"dd/MM/yyyy HH:mm:ss"}
                              />

                              <FormInputText
                                attribute="usuarioEnvioCertificado"
                                description={props.t(
                                  "empresa.edicao.accordion.certificado.usuario"
                                )}
                                value={usuarioEnvioCertificado}
                                setValue={setUsuarioDataEnvioCertificado}
                                disabled={true}
                              />
                            </div>
                          </div>
                        </Form>
                      </CardBody>
                    </Card>
                  </Collapse>

                  <Collapse isOpen={accordionRegistroLicencas}>
                    <Card>
                      <CardBody>
                        <CardTitle className="mb-4">
                          {props.t(
                            "empresa.edicao.accordion.registro-licencas.label"
                          )}
                        </CardTitle>
                        <EmpresaLicencaLista
                          listaLicenca={props.licencas}
                          loading={props.licencasLoading}
                        ></EmpresaLicencaLista>
                      </CardBody>
                    </Card>
                  </Collapse>

                  <Collapse isOpen={accordionTarefas}>
                    <Card>
                      <CardBody>
                        <CardTitle className="mb-4">
                          {props.t("empresa.edicao.accordion.tarefas.label")}
                        </CardTitle>
                        <EmpresaTarefaLista
                          listaTarefa={props.tarefas}
                          loading={props.tarefasLoading}
                        ></EmpresaTarefaLista>
                      </CardBody>
                    </Card>
                  </Collapse>

                  <Collapse isOpen={accordionNotificacoes}>
                    <Card>
                      <CardBody>
                        <CardTitle className="mb-4">
                          {props.t(
                            "empresa.edicao.accordion.notificacoes.label"
                          )}
                        </CardTitle>
                        <EmpresaNotificacaoLista
                          listaNotificacao={props.notificacoesSistema}
                          loading={props.notificacoesSistemaLoading}
                        ></EmpresaNotificacaoLista>
                      </CardBody>
                    </Card>
                  </Collapse>

                  <Collapse isOpen={accordionConfigIfood}>
                    <Card>
                      <CardBody>
                        <CardTitle className="mb-4">
                          {props.t(
                            "empresa.edicao.accordion.config-ifood.label"
                          )}
                        </CardTitle>
                        <EmpresaConfigIfoodLista
                          listaConfiguracoes={props.configIfood}
                          loading={props.configIfoodLoading}
                          empresa={empresaId}
                          usePermissionEdit={usePermissionEdit && podeGravar()}
                        ></EmpresaConfigIfoodLista>
                      </CardBody>
                    </Card>
                  </Collapse>

                  <Collapse isOpen={accordionGASS}>
                    <Card>
                      <CardBody>
                        <CardTitle className="mb-4">GASS</CardTitle>
                        <Form>
                          <div className="outer">
                            <div className="outer">
                              <FormGroup className="mb-4" row>
                                <Label
                                  htmlFor="chaveGASS"
                                  className="col-form-label col-lg-2"
                                >
                                  Chave
                                </Label>
                                <Col lg="7">
                                  <input
                                    type="text"
                                    id="chaveGASS"
                                    className="form-control"
                                    value={chaveGASS || ""}
                                    disabled
                                    readOnly
                                  />
                                  <small className="text-muted">
                                    {props.t(
                                      "empresa.edicao.accordion.gass-label"
                                    )}
                                  </small>
                                </Col>
                                <Col lg="3" className="mt-lg-0">
                                  <Button
                                    color="secondary"
                                    className="waves-effect waves-light"
                                    type="button"
                                    disabled={
                                      !usePermissionEdit || !podeGravar()
                                    }
                                    onClick={() => setChaveGASS(uuidv4())}
                                  >
                                    {props.t(
                                      "empresa.edicao.accordion.gass-button"
                                    )}
                                  </Button>
                                </Col>
                              </FormGroup>
                            </div>
                          </div>
                        </Form>
                      </CardBody>
                    </Card>
                  </Collapse>

                  <Collapse isOpen={accordionTarefasAgendadas}>
                    <Card>
                      <CardBody>
                        <CardTitle className="mb-4">
                          {props.t("menu.label.scheduled-reports")}
                        </CardTitle>

                        <EmpresaRelatorioLista
                          empresa={empresaId}
                          empresaAgenda={props.empresaAgenda}
                          loading={props.empresaAgendaLoading}
                          usePermissionEdit={usePermissionEdit && podeGravar()}
                        ></EmpresaRelatorioLista>
                      </CardBody>
                    </Card>
                  </Collapse>

                  <Card>
                    <CardBody>
                      <CardTitle className="mb-4">
                        {props.t("empresa.edicao.dados.alteracao")}
                      </CardTitle>
                      <Form>
                        <div className="outer">
                          <div className="outer">
                            <FormInputDate
                              attribute="dataAlteracao"
                              description={props.t(
                                "empresa.edicao.data.alteracao"
                              )}
                              value={dataAlteracao}
                              disabled={true}
                              dateFormat={"dd/MM/yyyy HH:mm:ss"}
                              withHour={true}
                            />

                            <FormInputText
                              attribute="usuarioAlteracao"
                              description={props.t(
                                "empresa.edicao.usuario.alteracao"
                              )}
                              value={usuarioAlteracao}
                              disabled={true}
                            />
                          </div>
                        </div>
                      </Form>
                    </CardBody>
                  </Card>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      )}
    </React.Fragment>
  )
}

CadastrarEmpresa.propTypes = {
  empresaAtivo: PropTypes.any,
  empresa: PropTypes.any,
  empresaLoading: PropTypes.bool,
  permanecerCadastro: PropTypes.any,
  empresaLicencas: PropTypes.any,
  empresaLicencasLoading: PropTypes.bool,
  empresaTarefas: PropTypes.any,
  empresaTarefasLoading: PropTypes.bool,
  empresaNotificacoes: PropTypes.any,
  empresaNotificacoesLoading: PropTypes.bool,
  novoEmpresaObservacao: PropTypes.any,

  buscarEmpresa: PropTypes.func,
  editarEmpresa: PropTypes.func,
  buscarTarefasPorEmpresa: PropTypes.func,
  cadastrarEmpresaObservacao: PropTypes.func,
  removerEmpresaObservacao: PropTypes.func,
  editarEmpresaObservacao: PropTypes.func,
}

const mapStatetoProps = state => {
  const {
    empresaAtivo,
    empresa,
    empresaLoading,
    licencas,
    licencasLoading,
    tarefas,
    tarefasLoading,
    notificacoesSistema,
    notificacoesSistemaLoading,
    tiposEmpresa,
    tiposEmpresaLoading,
    configIfood,
    configIfoodLoading,
    empresaAgenda,
    empresaAgendaLoading,
  } = state.Profile
  const { user } = state.Login
  return {
    user,
    empresaAtivo,
    empresa,
    empresaLoading,
    licencas,
    licencasLoading,
    tarefas,
    tarefasLoading,
    notificacoesSistema,
    notificacoesSistemaLoading,
    tiposEmpresa,
    tiposEmpresaLoading,
    configIfood,
    configIfoodLoading,
    empresaAgenda,
    empresaAgendaLoading,
  }
}

export default withTranslation()(
  connect(mapStatetoProps, {
    editarEmpresa,
    buscarEmpresa,
    buscarTarefasPorEmpresa,
    buscarLicencasPorEmpresa,
    buscarTiposEmpresa,
    buscarNotificacoesSistemaPorEmpresa,
    navegarBreadCrumb,
    navegarEditarEmpresa,
    buscarConfigIfoodPorEmpresa,
    buscarAgendaPorEmpresa,
  })(withRouter(CadastrarEmpresa))
)
